import { render, staticRenderFns } from "./AsignacionCategoriaUsuario.vue?vue&type=template&id=80b41b3e&"
import script from "./AsignacionCategoriaUsuario.vue?vue&type=script&lang=js&"
export * from "./AsignacionCategoriaUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports